import { Box, Button, Card, CardContent, Input, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import api from '../../../services/api';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import { ANAO, ASIM } from 'consts';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import { Link } from 'react-router-dom';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

class MsgWhatsAppFornecedorList extends Component {
    state = {
        mensagens: [],
        searchFilter: {
            descricaoMensagem: '',
            situacaoInativoFilter: ANAO,
        }
    };

    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right', // alinhamento a direita
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red',
        },
    };

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        this.loadMensagens();
    }

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { searchFilter } = this.state;
        let { name, value } = event.target;
        value = value.toUpperCase();
        searchFilter[name] = value;
        this.setState({ searchFilter }, () => {
            if (name === 'situacaoInativoFilter') {
                this.loadMensagens();
            }
        });
    };

    loadMensagens = async () => {
        const { searchFilter } = this.state;
        let active = '';

        if (searchFilter.situacaoInativoFilter === ANAO) {
            active = '/active/true'
        } else if (searchFilter.situacaoInativoFilter === ASIM) {
            active = '/active/false'
        }

        let params = '';

        /* consulta pela descrição da mensagem */
        if (searchFilter.descricaoMensagem) {
            params += `?tbmsgwhatsfornecedor.descricao=_like_${searchFilter.descricaoMensagem}`;
        }

        const mensagens = await api.get(`/whatsapp/mensagemfornecedor${active}${params}`);
        this.setState({ mensagens: mensagens.data });
    };

    /* Limpa Filtros na tela */
    LimpaFiltros = () => {
        let { searchFilter } = this.state;
        searchFilter.descricaoMensagem = '';
        searchFilter.situacaoInativoFilter = ANAO;
        this.setState({ searchFilter });
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true, messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* abre janela confirmação para exclusão */
    handleOpenDeleteMsgConfirmation = (codmensagem) => {
        this.setState({ openDeleteMsgConfirmation: true });
        this.handleSelectMsg(codmensagem);
    };

    handleSelectMsg = (id) => {
        this.setState({ selectedMsg: id });
    };

    handleCloseDeleteMsgConfirmation = () => {
        this.setState({ openDeleteMsgConfirmation: false });
    };

    handleDeleteMsg = async (id) => {
        try {
            const response = await api.delete(`/whatsapp/mensagemfornecedor/${id}`);
            if (response.status === 200) {
                this.handleCloseDeleteMsgConfirmation();
                this.loadMensagens();
            }
        } catch (error) {
            this.handleCloseDeleteMsgConfirmation();
            this.handleOpenAlert(error.response.data.error);
            console.log(error.message);
        }
    };

    onClickVoltar = () => {
        this.props.history.push('/crm/grupomsgwhatsappfornecedor');
    };

    render() {
        const { searchFilter } = this.state;
        const { mensagens } = this.state;

        return (
            <div style={this.estilo}>
                <div>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                            backgroundColor: '#ffffff',
                            padding: '10px 16px',
                            borderRadius: '8px 8px 0 0',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <Typography
                            variant="h4"
                            style={{
                                fontWeight: 600,
                                letterSpacing: '0.5px',
                            }}
                        >
                            MENSAGENS WHATSAPP
                        </Typography>

                        <Box style={{ display: 'flex', gap: 10 }}>
                            <Button
                                component={Link}
                                to="/crm/msgwhatsappfornecedor/novo"
                                variant="contained"
                                color="primary"
                                style={this.estilo.addButton}
                            >
                                Nova mensagem
                            </Button>
                        </Box>
                    </Box>

                    <Paper style={{ marginBottom: 10, marginTop: 10, padding: 10 }}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                            <Input
                                autoFocus
                                id="descricaoMensagem"
                                name="descricaoMensagem"
                                onChange={this.OnChangeSearch}
                                placeholder="Descrição da mensagem a pesquisar"
                                style={{ width: 300 }}
                                value={searchFilter.descricaoMensagem}
                            />

                            <Select
                                id="situacaoInativoFilter"
                                name="situacaoInativoFilter"
                                value={searchFilter.situacaoInativoFilter || ''}
                                onChange={this.OnChangeSearch}
                            >
                                <MenuItem value={ANAO}>Ativos</MenuItem>
                                <MenuItem value={ASIM}>Inativos</MenuItem>
                                <MenuItem value={'T'}>Todos</MenuItem>
                            </Select>

                            <Button color="primary" id="pesquisar" onClick={this.loadMensagens}>
                                <SearchIcon />
                            </Button>

                            <Button color="primary" onClick={this.LimpaFiltros}>
                                <ClearAllIcon />
                            </Button>
                        </Box>
                    </Paper>

                    <Card>
                        <CardContent>
                            <PerfectScrollbar>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: '100px', maxWidth: '100px' }}>Código</TableCell>
                                            <TableCell>Mensagem</TableCell>
                                            <TableCell>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {mensagens.map(mensagem => (
                                            <TableRow hover>
                                                <TableCell style={(mensagem.inativo === ASIM) ? this.estilo.redText : {}}>{mensagem.idmsgwhats}</TableCell>
                                                <TableCell style={(mensagem.inativo === ASIM) ? this.estilo.redText : {}}>{mensagem.descricao}</TableCell>
                                                <TableCell>
                                                    <Link to={`/crm/msgwhatsappfornecedor/${mensagem.idmsgwhats}`}>
                                                        <EditOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={() => this.handleOpenDeleteMsgConfirmation(mensagem.idmsgwhats)}
                                                        style={{ cursor: 'pointer', marginRight: '10px' }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </PerfectScrollbar>
                        </CardContent>
                    </Card>

                    <Button
                        name="voltar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickVoltar}
                        style={{ marginTop: '10px' }}
                    >
                        Voltar
                    </Button>
                </div>

                <div>
                    {/* Alerta de Informação */}
                    <AlertInformation
                        open={this.state.openAlert}
                        handleClose={this.handleCloseAlert}
                        message={this.state.messageAlert}
                    />

                    {/* Modal de Confirmação de Exclusão */}
                    <DeleteConfirmationModal
                        open={this.state.openDeleteMsgConfirmation}
                        handleClose={this.handleCloseDeleteMsgConfirmation}
                        itemId={this.state.selectedMsg}
                        message={"Confirma exclusão da mensagem " + this.state.selectedMsg + '?'}
                        handleDelete={() => this.handleDeleteMsg(this.state.selectedMsg)}
                    />
                </div>
            </div>
        );
    }
}

export default MsgWhatsAppFornecedorList;